export default {
    when() {
        return document.querySelectorAll('#sticky-segment-wrap').length > 0;
    },

    mounted() {
        const segmentPositionElement = document.querySelector(
            '#sticky-segment-position'
        );
        const stickySegment = document.querySelector('#sticky-segment-wrap');

        const getPos = (el) => {
            let lx = 0,
                ly = 0;
            while (el) {
                lx += el.offsetLeft;
                ly += el.offsetTop;
                el = el.offsetParent;
            }
            return { x: lx, y: ly };
        };

        const createDiv = (id, parentSelector) => {
            const div = document.createElement('div');
            div.id = id;
            document.querySelector(parentSelector).appendChild(div);
            return div;
        };

        const wrapper = createDiv('sticky-segment-navigation-wrapper', '#app');
        const container = createDiv(
            'sticky-segment-navigation-container',
            '#sticky-segment-navigation-wrapper'
        );
        const row = createDiv(
            'sticky-segment-navigation-wrapper-row',
            '#sticky-segment-navigation-container'
        );

        const stickySegmentNavigation = document.querySelector(
            '#sticky-segment-navigation'
        );
        const clone = stickySegmentNavigation.cloneNode(true);
        clone.id = 'sticky-segment-navigation-cloned';
        row.appendChild(clone);

        let prevScrollpos = window.pageYOffset;

        const handleScroll = () => {
            const segmentPosition = getPos(segmentPositionElement);
            const currentScrollPos = window.scrollY;

            if (currentScrollPos > segmentPosition.y - 20) {
                wrapper.style.display = 'block';
                wrapper.style.left = `${segmentPosition.x}px`;
                wrapper.style.top = '30px';
                stickySegment.style.display = 'none';
            } else {
                wrapper.style.display = 'none';
                stickySegment.style.position = 'static';
                stickySegment.style.display = 'block';
            }

            prevScrollpos = currentScrollPos;
        };

        window.addEventListener('scroll', handleScroll);
    },
};
